// extracted by mini-css-extract-plugin
export var off = "styles-module--off--37057";
export var on = "styles-module--on--01749";
export var thumb = "styles-module--thumb--33808";
export var toggle = "styles-module--toggle--d81cb";